import PropTypes from "prop-types";
import clsx from "clsx";

// MUI
import { Typography } from "@mui/material";

function TitleToolbar(props) {
	const { label, classes, sx } = props;

	return (
		<Typography
			py={1}
			className={clsx({
				"page-title": true,
				[classes]: Boolean(classes),
			})}
			component="div"
			sx={sx}
		>
			{label}
		</Typography>
	);
}

TitleToolbar.propTypes = {
	label: PropTypes.string,
	classes: PropTypes.string,
	sx: PropTypes.object,
};

export default TitleToolbar;
